export const PARENT_SETTINGS_FIELD = '__parentSettings';
